import React from 'react'
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import LogoLargo from '../assets/logo-largo.png'
import User from "./User";
import AppMenuRight from "./AppMenuRight";
import ManualUsuario from "../assets/manual_usuario_pqr.pdf";
import IconButton from "@material-ui/core/IconButton";
import HelpIcon from "@material-ui/icons/Help";

const AppMenu = () => {

    return (
        <AppBar position="static">
            <Toolbar>

                <div>
                    <a href={ManualUsuario} target='_blank' rel="noopener noreferrer">
                        <IconButton>
                            <HelpIcon style={{color: 'white'}} fontSize='large'/>
                        </IconButton>
                    </a>
                </div>

                <div className='center'>
                    <img className='logo-menu' src={LogoLargo} alt='Logo' style={{width: '150px'}}/>
                </div>

                <div className='right' style={{display: 'inline'}}>
                    <User/>
                    <AppMenuRight/>
                </div>

            </Toolbar>
        </AppBar>
    );
}
export default AppMenu